module.exports = __webpack_public_path__ + "static/media/grand.c844cbba.JPG";